<template>
	<!-- 订单二次确认 -->
	<dialog-form
		:dialogVisible="orderDialogVisible"
		:attributes="attributes"
		@close:dialogVisible="val => (orderDialogVisible = val)"
		@confirm="confirm"
	>
		<el-row :gutter="20" slot="main">
			<!-- 订单列表 -->
			<el-col :span="8">
				<el-row class="list">
					<el-col :span="24" class="title-list">订单信息</el-col>
					<div class="data-list">
						<el-col
							:span="24"
							v-for="(item, index) in copyOrderList"
							:key="index"
							:style="{ backgroundColor: item.bgc }"
							class="orderListItem"
							@click.native="showOrderList(item.id, index)"
						>
							<div class="order-list">
								<popover-text
									class="order-code"
									:text="`${item.orderCode}(${item.orderTypeName})`"
									:subText="`${item.orderCode}(${item.orderTypeName})`"
									:textStyle="{
										textAlign: 'left',
									}"
								></popover-text>
								<div class="spec">规格</div>
								<div class="count">数量</div>
							</div>
							<div class="item-list" v-for="(val, _index) in item.functionList" :key="_index">
								<div class="item-code">{{ val.name }}</div>
								<div class="item-spec">{{ val.number }}{{ val.unitName }}</div>
								<div class="item-count">{{ val.purchaseQuantity }}</div>
							</div>
						</el-col>
						<div class="hint" v-if="!nextOrderCountTotal">暂无数据</div>
					</div>
				</el-row>
			</el-col>
			<!-- 客户信息 -->
			<el-col :span="16">
				<el-row class="customer-data">
					<el-col :span="24" class="title-list">
						服务单确认
						<ig-icon name="qudaoshang" class="qudaoshang" v-if="agentName"></ig-icon>
						<div class="reorder" v-show="orderType === 2">续单</div>
					</el-col>
					<el-col :span="24" class="dialogScroll">
						<form-combination
							ref="formOrder"
							style="padding-right: 20px"
							size="small"
							:form-data="serviceConfirmation"
						></form-combination>
					</el-col>
				</el-row>
			</el-col>
		</el-row>
	</dialog-form>
</template>

<script>
import dialogForm from '@/components/dialogForm/dialogForm';
import formCombination from '@/components/iglobalwin/formCombination/formCombination.vue';
import popoverText from '@/components/tools/popoverText.vue';
export default {
	props: [
		'orderAttributes',
		'orderList',
		'nextOrderCountTotal',
		'orderType',
		'agentName',
		'serviceConfirmation',
	],
	data() {
		return {
			copyOrderList: [],
			orderDialogVisible: false,
			attributes: {
				width: '70%',
				top: '4vh',
			},
		};
	},
	methods: {
		confirm(cb) {
			this.$refs.formOrder.validate(val => {
				if (val) {
					this.$emit('confirm', cb);
				} else {
					cb(false);
				}
			});
		},
		showOrderList(val, index) {
			this.forDataBgc(this.copyOrderList, index);
			this.$emit('showOrderList', val);
		},
		forDataBgc(data, index) {
			if (!data) return false;
			data.forEach((item, idx) => {
				if (idx == index) {
					item.bgc = '#c9e6f1';
				} else {
					item.bgc = '#fff';
				}
			});
		},
	},
	watch: {
		orderList: {
			handler(val) {
				this.copyOrderList = val.concat();
				this.forDataBgc(this.copyOrderList, 0);
			},
			deep: true,
		},
	},
	components: { dialogForm, formCombination, popoverText },
};
</script>

<style lang="scss" scoped>
.list {
	width: 100%;

	.title-list {
		text-align: center;
		margin-bottom: 24px;
		font-weight: 600;
		font-size: 20px;
		line-height: 34px;
	}

	.data-list {
		width: 100%;
		height: 650px;
		overflow-y: auto;

		.orderListItem {
			margin-bottom: 20px;
			padding-bottom: 10px;
			cursor: pointer;
			user-select: none;
			border-bottom: 1px solid #d8d8d8;

			.order-list,
			.item-list {
				display: flex;
				justify-content: space-between;
				align-items: center;
				text-align: center;

				.order-code,
				.spec,
				.count {
					font-size: 16px;
					padding: 2px 5px;
					font-weight: bold;
					text-align: right;
				}

				.order-code,
				.item-code {
					flex: 2;
				}

				.spec,
				.item-spec {
					flex: 1;
				}

				.count,
				.item-count {
					flex: 1;
				}
			}

			.item-list {
				width: 100%;
				padding: 4px 0;
				font-size: 14px;

				.item-code,
				.item-spec,
				.item-count {
					padding: 2px 5px;
					text-align: right;
				}

				.item-code {
					text-align: left;
				}
			}
		}

		.hint {
			width: 100%;
			text-align: center;
			color: #999;
		}
		// 改变滚动条样式
		&::-webkit-scrollbar {
			width: 4px;
		}

		&::-webkit-scrollbar-thumb {
			background-color: #d8d8d8;
			border-radius: 2px;
		}

		&::-webkit-scrollbar-track {
			background-color: #fff;
			border-radius: 2px;
		}
	}
}

.customer-data {
	width: 100%;

	.title-list {
		text-align: center;
		margin-bottom: 20px;
		font-weight: 600;
		font-size: 20px;
		line-height: 34px;
		position: relative;

		.title {
			height: 34px;
			line-height: 34px;
		}

		.reorder {
			position: absolute;
			top: 0;
			right: 0;
			width: 72px;
			height: 34px;
			line-height: 34px;
			font-size: 16px;
			// background-color: rgba(84, 168, 254, 0.5);
			border: 1px solid #54a8fe;
			border-radius: 4px;
			color: #54a8fe;
			text-align: center;
			font-weight: 400;
		}
	}

	.dialogScroll {
		width: 100%;
		height: 650px;
		overflow-y: auto;
	}
	// 改变滚动条样式
	.dialogScroll::-webkit-scrollbar {
		width: 4px;
	}

	.dialogScroll::-webkit-scrollbar-thumb {
		background-color: #d8d8d8;
		border-radius: 2px;
	}

	.dialogScroll::-webkit-scrollbar-track {
		background-color: #fff;
		border-radius: 2px;
	}
}
.qudaoshang {
  font-weight: 400;
  font-size: 21px;
  margin-right: 10px;
  color: #67c23a;
}
</style>
